// extracted by mini-css-extract-plugin
export default {"google-authentication-button":"GoogleAuthenticationButton_google-authentication-button__qNEuS","google-icon":"GoogleAuthenticationButton_google-icon__7dKJ4"};